import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export interface CharacterRow {
  id: string;
  name: string;
  age: number | null;
  images: string[];
  link: string;
  description: string;
  tags: string[];
  area: string;
  lat: number;
  lng: number;
  is_active: boolean;
  catchphrase: string;
  height: number | null;
  hobby: string;
  type: string;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export function rowToCharacter(row: CharacterRow) {
  return {
    id: row.id,
    name: row.name,
    age: row.age ?? null,
    images: row.images ?? [],
    link: row.link ?? "",
    description: row.description ?? "",
    tags: row.tags ?? [],
    area: row.area ?? "",
    lat: row.lat ?? 35.6762,
    lng: row.lng ?? 139.6503,
    isActive: row.is_active ?? true,
    catchphrase: row.catchphrase ?? "",
    height: row.height ?? null,
    hobby: row.hobby ?? "",
    type: row.type ?? "",
    sort_order: row.sort_order ?? 0,
  };
}

export function characterToRow(char: ReturnType<typeof rowToCharacter>) {
  return {
    name: char.name,
    // null をそのまま保存（DBカラムはNULL許容）
    age: char.age ?? null,
    images: char.images,
    link: char.link,
    description: char.description,
    tags: char.tags,
    area: char.area,
    lat: char.lat,
    lng: char.lng,
    is_active: char.isActive,
    catchphrase: char.catchphrase,
    height: char.height ?? null,
    hobby: char.hobby,
    type: char.type,
    sort_order: char.sort_order ?? 0,
  };
}
